import {CSSProperties} from 'styled-components'
import {GridProps} from '../../../../components/ui/grid-atoms/GridAtoms'
import {StyledSwitchField} from './style'

export const SwitchField = ({height, ...props}: GridProps & {height?: CSSProperties['height']}) => (
    <StyledSwitchField $height={height} {...props} />
)
